import { AnyObject, QueryParams } from '~shared/types';
import { apiService } from '~shared/api';
import { MetaDto } from '@/types/api';
import { joinQueryParams } from '~shared/lib';

const urlPath = '/doctors';

// TODO: типизация
export const getList = async (query: QueryParams = {}) => {
  const response = await apiService.api.instance.get<{ data: AnyObject[]; meta: MetaDto }>(
    joinQueryParams({
      url: urlPath,
      query: query,
    })
  );

  return {
    ...response.data,
  };
};
